import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './TutorReordering.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function TutorReordering(prop) {	
	const navigate = useNavigate();
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [tutors, setTutors] = useState([]);
	const fetchData = () => {		
		getData('tutorApi/listTutor', navigate)
		.then(res => {
				let tt = res.data;
				for(let t of tt) {
					t.tutorId = t.tutorId.toString();
				}
				
				setTutors(tt);
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const updateTutorOrdering = (newTutors) => {
		console.log(newTutors);
		let objs = [];
		
		for (let i = 0; i < newTutors.length; i++) {
			objs.push({tutorId:newTutors[i].tutorId, ordering:i});
		}
		
		let param = {
			tutors:objs
		}
		
		postData("tutorApi/reorderTutorOrdering", param, navigate); 
	}
	
	const onDragEnd = async (result) => {
    if (!result.destination) return;
    const newTutors = Array.from(tutors);
    const [removed] = newTutors.splice(result.source.index, 1);
    newTutors.splice(result.destination.index, 0, removed);
		updateTutorOrdering(newTutors);
    setTutors(newTutors);
  };
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
		
		{
			<DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="tutors">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} 
						style={{display:"flex", flexDirection:"column", gap:"2px", flexWrap: "wrap", alignItems:"center"}}>
            {tutors.map((tutor, index) => (
              <Draggable key={tutor.tutorId} draggableId={tutor.tutorId} index={index}>
                {(provided) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}>
										<TutorDisplay t={tutor} />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
			
			
		}
	</div>);
	
}


const TutorDisplay = ({t}) => {
	
	return (<div style={{border:"1px solid #22222222", fontSize:"0.8rem", textAlign:"left", padding:"10px"}}>
		<div style={{display:"flex", width:"200px", gap:"5px"}}>
			<div>{t.tutorId}</div>
			<div>{t.displayName}</div>
		</div>
	</div>);
}